module.exports = __webpack_public_path__ + "static/media/floor7.02a8458e.png";